import { render, staticRenderFns } from "./smallDialog.vue?vue&type=template&id=995ef718&scoped=true"
import script from "./smallDialog.vue?vue&type=script&lang=js"
export * from "./smallDialog.vue?vue&type=script&lang=js"
import style0 from "./smallDialog.vue?vue&type=style&index=0&id=995ef718&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "995ef718",
  null
  
)

export default component.exports